import React, { useState } from "react"
import FAQItem from "./faq-item"

import "./faq.scss"

const FAQ = props => {
  const [isOpen, setIsOpen] = useState()

  return (
    <div className={`faq ${props.color_theme === "light" ? "light" : "dark"}`}>
      <div className="container">
        {props.headline && (
          <div className="table__headline">
            <h4 className="headline">{props.headline}</h4>
          </div>
        )}
        {props.faq.map((faq, index) => {
          return (
            <div className="faq-item" key={index}>
              <div
                className="faq-item__question"
                onClick={() => setIsOpen(isOpen === index ? null : index)}
              >
                <p>{faq.faq_item.question}</p>
                <svg
                  style={
                    isOpen === index ? { transform: "rotateX(180deg)" } : {}
                  }
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  className="dropdown-icon"
                >
                  <path d="M7 10l5 5 5-5z" />
                  <path d="M0 0h24v24H0z" fill="none" />
                </svg>
              </div>
              <div className="faq-item__answer">
                <FAQItem
                  index={index}
                  isOpen={isOpen}
                  answer={faq.faq_item.answer}
                />
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default FAQ
